/**
* jquery-match-height master by @liabru
* http://brm.io/jquery-match-height/
* License: MIT
*/

;(function(factory) { // eslint-disable-line no-extra-semi
  'use strict';
  if (typeof define === 'function' && define.amd) {
      // AMD
      define(['jquery'], factory);
  } else if (typeof module !== 'undefined' && module.exports) {
      // CommonJS
      module.exports = factory(require('jquery'));
  } else {
      // Global
      factory(jQuery);
  }
})(function($) {
  /*
  *  internal
  */

  var _previousResizeWidth = -1,
      _updateTimeout = -1;

  /*
  *  _parse
  *  value parse utility function
  */

  var _parse = function(value) {
      // parse value and convert NaN to 0
      return parseFloat(value) || 0;
  };

  /*
  *  _rows
  *  utility function returns array of jQuery selections representing each row
  *  (as displayed after float wrapping applied by browser)
  */

  var _rows = function(elements) {
      var tolerance = 1,
          $elements = $(elements),
          lastTop = null,
          rows = [];

      // group elements by their top position
      $elements.each(function(){
          var $that = $(this),
              top = $that.offset().top - _parse($that.css('margin-top')),
              lastRow = rows.length > 0 ? rows[rows.length - 1] : null;

          if (lastRow === null) {
              // first item on the row, so just push it
              rows.push($that);
          } else {
              // if the row top is the same, add to the row group
              if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
                  rows[rows.length - 1] = lastRow.add($that);
              } else {
                  // otherwise start a new row group
                  rows.push($that);
              }
          }

          // keep track of the last row top
          lastTop = top;
      });

      return rows;
  };

  /*
  *  _parseOptions
  *  handle plugin options
  */

  var _parseOptions = function(options) {
      var opts = {
          byRow: true,
          property: 'height',
          target: null,
          remove: false
      };

      if (typeof options === 'object') {
          return $.extend(opts, options);
      }

      if (typeof options === 'boolean') {
          opts.byRow = options;
      } else if (options === 'remove') {
          opts.remove = true;
      }

      return opts;
  };

  /*
  *  matchHeight
  *  plugin definition
  */

  var matchHeight = $.fn.matchHeight = function(options) {
      var opts = _parseOptions(options);

      // handle remove
      if (opts.remove) {
          var that = this;

          // remove fixed height from all selected elements
          this.css(opts.property, '');

          // remove selected elements from all groups
          $.each(matchHeight._groups, function(key, group) {
              group.elements = group.elements.not(that);
          });

          // TODO: cleanup empty groups

          return this;
      }

      if (this.length <= 1 && !opts.target) {
          return this;
      }

      // keep track of this group so we can re-apply later on load and resize events
      matchHeight._groups.push({
          elements: this,
          options: opts
      });

      // match each element's height to the tallest element in the selection
      matchHeight._apply(this, opts);

      return this;
  };

  /*
  *  plugin global options
  */

  matchHeight.version = 'master';
  matchHeight._groups = [];
  matchHeight._throttle = 80;
  matchHeight._maintainScroll = false;
  matchHeight._beforeUpdate = null;
  matchHeight._afterUpdate = null;
  matchHeight._rows = _rows;
  matchHeight._parse = _parse;
  matchHeight._parseOptions = _parseOptions;

  /*
  *  matchHeight._apply
  *  apply matchHeight to given elements
  */

  matchHeight._apply = function(elements, options) {
      var opts = _parseOptions(options),
          $elements = $(elements),
          rows = [$elements];

      // take note of scroll position
      var scrollTop = $(window).scrollTop(),
          htmlHeight = $('html').outerHeight(true);

      // get hidden parents
      var $hiddenParents = $elements.parents().filter(':hidden');

      // cache the original inline style
      $hiddenParents.each(function() {
          var $that = $(this);
          $that.data('style-cache', $that.attr('style'));
      });

      // temporarily must force hidden parents visible
      $hiddenParents.css('display', 'block');

      // get rows if using byRow, otherwise assume one row
      if (opts.byRow && !opts.target) {

          // must first force an arbitrary equal height so floating elements break evenly
          $elements.each(function() {
              var $that = $(this),
                  display = $that.css('display');

              // temporarily force a usable display value
              if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                  display = 'block';
              }

              // cache the original inline style
              $that.data('style-cache', $that.attr('style'));

              $that.css({
                  'display': display,
                  'padding-top': '0',
                  'padding-bottom': '0',
                  'margin-top': '0',
                  'margin-bottom': '0',
                  'border-top-width': '0',
                  'border-bottom-width': '0',
                  'height': '100px',
                  'overflow': 'hidden'
              });
          });

          // get the array of rows (based on element top position)
          rows = _rows($elements);

          // revert original inline styles
          $elements.each(function() {
              var $that = $(this);
              $that.attr('style', $that.data('style-cache') || '');
          });
      }

      $.each(rows, function(key, row) {
          var $row = $(row),
              targetHeight = 0;

          if (!opts.target) {
              // skip apply to rows with only one item
              if (opts.byRow && $row.length <= 1) {
                  $row.css(opts.property, '');
                  return;
              }

              // iterate the row and find the max height
              $row.each(function(){
                  var $that = $(this),
                      style = $that.attr('style'),
                      display = $that.css('display');

                  // temporarily force a usable display value
                  if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                      display = 'block';
                  }

                  // ensure we get the correct actual height (and not a previously set height value)
                  var css = { 'display': display };
                  css[opts.property] = '';
                  $that.css(css);

                  // find the max height (including padding, but not margin)
                  if ($that.outerHeight(false) > targetHeight) {
                      targetHeight = $that.outerHeight(false);
                  }

                  // revert styles
                  if (style) {
                      $that.attr('style', style);
                  } else {
                      $that.css('display', '');
                  }
              });
          } else {
              // if target set, use the height of the target element
              targetHeight = opts.target.outerHeight(false);
          }

          // iterate the row and apply the height to all elements
          $row.each(function(){
              var $that = $(this),
                  verticalPadding = 0;

              // don't apply to a target
              if (opts.target && $that.is(opts.target)) {
                  return;
              }

              // handle padding and border correctly (required when not using border-box)
              if ($that.css('box-sizing') !== 'border-box') {
                  verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
                  verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
              }

              // set the height (accounting for padding and border)
              $that.css(opts.property, (targetHeight - verticalPadding) + 'px');
          });
      });

      // revert hidden parents
      $hiddenParents.each(function() {
          var $that = $(this);
          $that.attr('style', $that.data('style-cache') || null);
      });

      // restore scroll position if enabled
      if (matchHeight._maintainScroll) {
          $(window).scrollTop((scrollTop / htmlHeight) * $('html').outerHeight(true));
      }

      return this;
  };

  /*
  *  matchHeight._applyDataApi
  *  applies matchHeight to all elements with a data-match-height attribute
  */

  matchHeight._applyDataApi = function() {
      var groups = {};

      // generate groups by their groupId set by elements using data-match-height
      $('[data-match-height], [data-mh]').each(function() {
          var $this = $(this),
              groupId = $this.attr('data-mh') || $this.attr('data-match-height');

          if (groupId in groups) {
              groups[groupId] = groups[groupId].add($this);
          } else {
              groups[groupId] = $this;
          }
      });

      // apply matchHeight to each group
      $.each(groups, function() {
          this.matchHeight(true);
      });
  };

  /*
  *  matchHeight._update
  *  updates matchHeight on all current groups with their correct options
  */

  var _update = function(event) {
      if (matchHeight._beforeUpdate) {
          matchHeight._beforeUpdate(event, matchHeight._groups);
      }

      $.each(matchHeight._groups, function() {
          matchHeight._apply(this.elements, this.options);
      });

      if (matchHeight._afterUpdate) {
          matchHeight._afterUpdate(event, matchHeight._groups);
      }
  };

  matchHeight._update = function(throttle, event) {
      // prevent update if fired from a resize event
      // where the viewport width hasn't actually changed
      // fixes an event looping bug in IE8
      if (event && event.type === 'resize') {
          var windowWidth = $(window).width();
          if (windowWidth === _previousResizeWidth) {
              return;
          }
          _previousResizeWidth = windowWidth;
      }

      // throttle updates
      if (!throttle) {
          _update(event);
      } else if (_updateTimeout === -1) {
          _updateTimeout = setTimeout(function() {
              _update(event);
              _updateTimeout = -1;
          }, matchHeight._throttle);
      }
  };

  /*
  *  bind events
  */

  // apply on DOM ready event
  $(matchHeight._applyDataApi);

  // use on or bind where supported
  var on = $.fn.on ? 'on' : 'bind';

  // update heights on load and resize events
  $(window)[on]('load', function(event) {
      matchHeight._update(false, event);
  });

  // throttled update heights on resize events
  $(window)[on]('resize orientationchange', function(event) {
      matchHeight._update(true, event);
  });

});


// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true
	},
};

(function() {
	BoostPFS.inject(this);
	
	ProductGridItem.prototype.compileTemplate = function(data) {
		if(!data) data = this.data;
		/*** Prepare data ***/
		// var aux = JSON.parse(Utils.getProductMetafield(data , "boost_custom", "selling_plans"))
		// data.selected_selling_plan_allocation = aux.selected_selling_plan_allocation
		// data.selling_plan_groups = aux.selling_plan_groups
		if (Utils.getProductMetafield(data, "boost_custom", "selling_plans") !== null) {
			var aux = JSON.parse(Utils.getProductMetafield(data, "boost_custom", "selling_plans"))
			data.selected_selling_plan_allocation = aux.selected_selling_plan_allocation
			data.selling_plan_groups = aux.selling_plan_groups
	}
		//console.log(data)
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
		
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var itemImagesHtml = '<div class="grid-view-item__image-wrapper js">';
		// itemImagesHtml += '<div>';
		// if (images.length > 0) {
		// 	aspect_ratio = images[0]['width'] / images[0]['height'];
		// 	itemImagesHtml += 1 / aspect_ratio * 100;
		// } else {
		// 	itemImagesHtml += 100;
		// }
		// itemImagesHtml += '">';
		itemImagesHtml += '<img id="" ' +
			'class="grid-view-item__image lazyload" ' +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
			'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
		// itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		/* Swym integration */
		var itemWishlistHtml = '<div class="swym-button swym-add-to-wishlist-view-product product_{{itemId}}" data-swaction="addToWishlist"  data-product-id="' + JSON.stringify(data.id) + '">'+ 
		'<img class="add-to-wishlist" src="https://cdn.shopify.com/s/files/1/0513/1809/6042/files/wishlist.svg?v=1613991032" alt="" data-wishlist-icon>' +
		'<img class="exists-in-wishlist" src="https://cdn.shopify.com/s/files/1/0513/1809/6042/files/wishlist-open.svg?v=1613991041" alt="" data-wishlist-icon>' +
		'</div>';
		itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishlistHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		// Quick add options to cards 
		var variantquickadd = boostPFSTemplate.variantquickadd; 
		var quickadd = boostPFSTemplate.quickadd;
		var host = window.location.hostname;
		var variantHref = 'href=/products/'+ data.handle; 
		var id = 'value=' + data.variants[0].id; 
		var flag = 'data-input-flag=' + data.variants[0].id;
		if(data.selling_plan_groups) {
			if(data.selling_plan_groups.length >= 1){
					var sellingPlanData = data.selling_plan_groups[0].selling_plans;
		
					var sellingPlan1 = sellingPlanData[0]
					var sellingPlan2 = sellingPlanData[1]
					var sellingPlan3 = sellingPlanData[2]
					
					if(sellingPlan1){
						var planData1 = "value=" + "'" + data.variants[0].id + "/" + sellingPlan1.id + "/" + sellingPlan1.name + "/"+ data.title + "'";
					}
					if(sellingPlan2){
						var planData2 = "value=" + "'" + data.variants[0].id + "/" + sellingPlan2.id + "/" + sellingPlan2.name + "/"+ data.title + "'";
					}
					if(sellingPlan3){
						var planData3 = "value=" + "'" + data.variants[0].id + "/" + sellingPlan3.id + "/" + sellingPlan3.name + "/"+ data.title + "'";
					}
					var planData4 = "value=" + "'" + data.variants[0].id + "/" + 'no plan' + "/" + 'one-off' + "/"+ data.title + "'";
				}
		}

		if(data.title.includes('Custom')) {
			var customBox = true; 
		} else {
			customBox = false; 
		}
		// itemHtml = itemHtml.replace(/{{variantId}}/g, 'test');
			if(data.options_with_values[0].values.length < 2 && customBox == false ) {
				itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, quickadd);
				if(planData1){
					itemHtml = itemHtml.replace(/{{plan1}}/g, planData1);
				} else {
					itemHtml = itemHtml.replace(/{{plan1}}/g, '');
				}
				if(planData2) {
					itemHtml = itemHtml.replace(/{{plan2}}/g, planData2);
				} else {
					itemHtml = itemHtml.replace(/{{plan2}}/g, '');
				}
				if(planData3) {
					itemHtml = itemHtml.replace(/{{plan3}}/g, planData3);
				} else {
					itemHtml = itemHtml.replace(/{{plan3}}/g, '');
				}
				if(planData4) {
					itemHtml = itemHtml.replace(/{{plan4}}/g, planData4);
				} else {
					itemHtml = itemHtml.replace(/{{plan4}}/g, '');
				}
				itemHtml = itemHtml.replace(/{{quickaddID}}/g, id) 
				itemHtml = itemHtml.replace(/{{inputFlag}}/g, flag)
			} else {
				itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, variantquickadd);
				if(planData1){
					itemHtml = itemHtml.replace(/{{plan1}}/g, planData1);
				} else {
					itemHtml = itemHtml.replace(/{{plan1}}/g, '');
				}
				if(planData2) {
					itemHtml = itemHtml.replace(/{{plan2}}/g, planData2);
				} else {
					itemHtml = itemHtml.replace(/{{plan2}}/g, '');
				}
				if(planData3) {
					itemHtml = itemHtml.replace(/{{plan3}}/g, planData3);
				} else {
					itemHtml = itemHtml.replace(/{{plan3}}/g, '');
				}
				if(planData4) {
					itemHtml = itemHtml.replace(/{{plan4}}/g, planData4);
				} else {
					itemHtml = itemHtml.replace(/{{plan4}}/g, '');
				}
				itemHtml = itemHtml.replace(/{{variantHref}}/g, variantHref);
			}
		// add wishlist to card 
		var wishlistCard = boostPFSTemplate.wishlistCard
		var wishlistID = 'data-product-id="' + data.variants[0].id + '"';
		itemHtml = itemHtml.replace(/{{wishlistCard}}/g, wishlistCard)
		itemHtml = itemHtml.replace(/{{wishlistID}}/g, wishlistID)
		// UK flag 
		var tags = data['tags']; 
		//flags
		var ukFlag = boostPFSTemplate.ukFlag;
		var argFlag = boostPFSTemplate.argFlag;
		var ausFlag = boostPFSTemplate.ausFlag;
		var braFlag = boostPFSTemplate.braFlag;
		var costaFlag = boostPFSTemplate.costaFlag;
		var egyFlag = boostPFSTemplate.egyFlag;
		var fraFlag = boostPFSTemplate.fraFlag;
		var greFlag = boostPFSTemplate.greFlag;
		var isrFlag = boostPFSTemplate.isrFlag;
		var itaFlag = boostPFSTemplate.itaFlag;
		var ivoryFlag = boostPFSTemplate.ivoryFlag;
		var nethFlag = boostPFSTemplate.nethFlag;
		var peruFlag = boostPFSTemplate.peruFlag;
		var southFlag = boostPFSTemplate.southFlag;
		var spainFlag = boostPFSTemplate.spainFlag;
		var usaFlag = boostPFSTemplate.usaFlag;
		var ukFlag = boostPFSTemplate.ukFlag;
		// straplines 
		var grownInUK = boostPFSTemplate.grownInUK;
		var grownInArg = boostPFSTemplate.grownInArg;
		var grownInAus = boostPFSTemplate.grownInAus;
		var grownInBra = boostPFSTemplate.grownInBra;
		var grownInCosta = boostPFSTemplate.grownInCosta;
		var grownInEyg = boostPFSTemplate.grownInEyg;
		var grownInFra = boostPFSTemplate.grownInFra;
		var grownInGre = boostPFSTemplate.grownInGre;
		var grownInIsr = boostPFSTemplate.grownInIsr;
		var grownInIta = boostPFSTemplate.grownInIta;
		var grownInIvory = boostPFSTemplate.grownInIvory;
		var grownInNeth = boostPFSTemplate.grownInNeth;
		var grownInPeru = boostPFSTemplate.grownInPeru;
		var grownInSouth = boostPFSTemplate.grownInSouth;
		var grownInSpain = boostPFSTemplate.grownInSpain;
		var grownInUsa = boostPFSTemplate.grownInUsa;
		var grownInBlank = boostPFSTemplate.grownInBlank;

		// flags
		if(tags.indexOf("produced-in: uk") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, ukFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInUK)
			
		} else if (tags.indexOf("produced-in: argentina") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, argFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInArg)

		} else if (tags.indexOf("produced-in: argentina") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, argFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInArg)

		}  else if (tags.indexOf("produced-in: austria") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, ausFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInAus)

		} else if (tags.indexOf("produced-in: brazil") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, braFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInBra)

		} else if (tags.indexOf("produced-in: costa-rica") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, costaFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInCosta)

		} else if (tags.indexOf("produced-in: egypt") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, egyFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInEyg)

		} else if (tags.indexOf("produced-in: france") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, fraFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInFra)

		} else if (tags.indexOf("produced-in: greece") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, greFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInGre)

		} else if (tags.indexOf("produced-in: israel") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, isrFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInIsr)

		} else if (tags.indexOf("produced-in: italy") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, itaFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInIta)

		} else if (tags.indexOf("produced-in: ivory-coast") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, ivoryFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInIvory)

		} else if (tags.indexOf("produced-in: the-netherlands") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, nethFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInNeth)

		} else if (tags.indexOf("produced-in: peru") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, peruFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInPeru)

		} else if (tags.indexOf("produced-in: south-africa") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, southFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInSouth)

		} else if (tags.indexOf("produced-in: spain") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, spainFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInSpain)

		} else if (tags.indexOf("produced-in: usa") > -1){
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, usaFlag)
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInUsa)

		} else {
			itemHtml = itemHtml.replace(/{{itemFlag}}/g, '')
			itemHtml = itemHtml.replace(/{{itemGrownIn}}/g, grownInBlank)
		}

		var dietRequirementsVegan = boostPFSTemplate.dietRequirementsVegan
		var dietRequirementsGluten = boostPFSTemplate.dietRequirementsGluten
		var dietRequirementsVegetarian = boostPFSTemplate.dietRequirementsVegetarian
		var dietRequirementsWheat = boostPFSTemplate.dietRequirementsWheat
		var dietRequirementsYeast = boostPFSTemplate.dietRequirementsYeast
		var dietRequirementsLactose = boostPFSTemplate.dietRequirementsLactose
		var dietRequirementsDairy = boostPFSTemplate.dietRequirementsDairy
		var dietRequirementsSugar = boostPFSTemplate.dietRequirementsSugar
		var dietRequirementsSalt = boostPFSTemplate.dietRequirementsSalt
		var dietRequirementsRaw = boostPFSTemplate.dietRequirementsRaw

		if(data.metafields.length > 0){
			if(data.metafields[0].key == 'short_description'){
				let shortDesc = data.metafields[0].value.toString(); 
				itemHtml = itemHtml.replace(/{{itemShortDesc}}/g, shortDesc)
			} else if(data.metafields[1]){
				if(data.metafields[1].key == 'short_description'){
					let shortDesc = data.metafields[1].value.toString(); 
					itemHtml = itemHtml.replace(/{{itemShortDesc}}/g, shortDesc)
				}
				else {
					itemHtml = itemHtml.replace(/{{itemShortDesc}}/g, '')
				}
			} 
			else {
				itemHtml = itemHtml.replace(/{{itemShortDesc}}/g, '')
			}
		} else {
			itemHtml = itemHtml.replace(/{{itemShortDesc}}/g, '')
		}

		if(data.metafields[0]) {
			let metaString = data.metafields[0].value.toString();
			var vegan = metaString.includes('Vegan');
			var gluten = metaString.includes('Gluten Free');
			var vegetarian = metaString.includes('Vegetarian');
			var wheat = metaString.includes('Wheat Free');
			var yeast = metaString.includes('Yeast Free');
			var lactose = metaString.includes('Lactose Free')
			var dairy = metaString.includes('Dairy Free')
			var sugar = metaString.includes('No Added Sugar')
			var salt = metaString.includes('Low Salt')
			var raw = metaString.includes('Raw')
			if(vegan == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsVegan}}/g, dietRequirementsVegan)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsVegan}}/g, '')
			}
			if(gluten == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsGluten}}/g, dietRequirementsGluten)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsGluten}}/g, '')
			}
			if(vegetarian == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsVegetarian}}/g, dietRequirementsVegetarian)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsVegetarian}}/g, '')
			}
			if(wheat == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsWheat}}/g, dietRequirementsWheat)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsWheat}}/g, '')
			}	
			if(yeast == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsYeast}}/g, dietRequirementsYeast)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsYeast}}/g, '')
			}	
			if(lactose == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsLactose}}/g, dietRequirementsLactose)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsLactose}}/g, '')
			}
			if(dairy == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsDairy}}/g, dietRequirementsDairy)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsDairy}}/g, '')
			}		
			if(sugar == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsSugar}}/g, dietRequirementsSugar)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsSugar}}/g, '')
			}	
			if(salt == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsSalt}}/g, dietRequirementsSalt)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsSalt}}/g, '')
			}		
			if(raw == true){
				itemHtml = itemHtml.replace(/{{itemDietRequirementsRaw}}/g, dietRequirementsRaw)
			} else {
				itemHtml = itemHtml.replace(/{{itemDietRequirementsRaw}}/g, '')
			}	
		} else {
			itemHtml = itemHtml.replace(/{{itemDietRequirementsVegan}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsGluten}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsVegetarian}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsWheat}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsYeast}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsLactose}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsDairy}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsSugar}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsSalt}}/g, '')
			itemHtml = itemHtml.replace(/{{itemDietRequirementsRaw}}/g, '')
		}

		// set metafield index 
		var ships = null;
		var fields = data.metafields; 
		fields.forEach((item) => {
			if(item.key == 'ships_outside_london'){
				ships = item.value.toUpperCase(); 
			}
		})

		let postcodeRegex = window.theme.settings.postcodeRegex;
		var customerCode = window.theme.settings.customerCode; 
		let array = postcodeRegex.replace(/ /g, '').split('|');

		let postcodeFull = customerCode.slice(0, 4);
		let postcodeThree = customerCode.slice(0, 3);
		let postcodeTwo = customerCode.slice(0, 2);

		let postcodeCheck = true;
		for (let i = 0; i < array.length; i++) {
			let postcode = array[i];
			
			if (postcode.includes(postcodeFull)) {
				postcodeCheck = false;
			}
			
			if (postcode.includes(postcodeThree)) {
				postcodeCheck = false;
			}
			
			if (postcode.includes(postcodeTwo)) {
				postcodeCheck = false;
			}
		}
		
		if (ships == 'NO' && postcodeCheck == true) {
			itemHtml = itemHtml.replace(/{{out-of-london}}/g, 'disabled')
		} else {
			itemHtml = itemHtml.replace(/{{out-of-london}}/g, '')
		}

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
	
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
	
		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
	
		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
	
		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
	
		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);
	
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
	
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
	
		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
	
		priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
		if (boostPFSConfig.custom.vendor_enable) {
			priceHtml += '<div class="price__vendor">';
			priceHtml += '<dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt>';
			priceHtml += '<dd class="hide">';
			priceHtml += data.vendor;
			priceHtml += '</dd>';
			priceHtml += '</div>';
		}
		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if (data.available) {
			if (onSale) {
				priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
			} else {
				priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
			priceHtml += boostPFSConfig.label.sold_out;
		}
		priceHtml += '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '<div class="price__sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd style="display: flex;">';
		priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
		priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		priceHtml += '</span> ';
		priceHtml += '<span class="price-item__label" aria-hidden="true" style="display: flex; margin-left: 5px;">' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '<div class="price__badge--sale" style="margin-left: 5px; padding:0 5px;">' + boostPFSThemeConfig.label.sale + '</div>' + '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '</dl>';
	
		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
	
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}
	
		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}
		/** Start Swym integration **/
		window.SwymCallbacks = window.SwymCallbacks || [];
		window.SwymCallbacks.push(function(swat) { 
				// Wrap with callback for loading without additional checks
				var products = [];
				data.forEach(function(product) {
						var image_src = Utils.getFeaturedImage(product.images_info);
						var productCopy = product;
						productCopy.featured_image = image_src;
						productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
						productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
						products.push(productCopy);
				});
				swat.mapShopifyProducts(products); // Product mapped data to swym layer
				swat.initializeActionButtons(Selector.products); // Buttons can now be initialized
		});
		/** End Swym integration **/
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		
		function handleQuantityChange() {
      // Number change event for cart update
      var cart_items = document.getElementsByClassName('cart-items')[0];
      var input = cart_items.querySelectorAll('.stepper-input');

      for(i=0; i < input.length; i++ ) {
         input[i].addEventListener('change', (e) => {
            updateItemQuantity(e.target);
         })
      }
   }

   function updateItemQuantity(input) {
      let val = input.value,
          index = input.getAttribute('data-line-item');
  
      var params = {
        url: '/cart/change.js',
        data: { quantity: val, line: index },
        dataType: 'json'
      };
  
      $.post(params)
        .done(
           setTimeout(function() {
            buildCartItems()
           }, 1000)
        )
    }
		function buildCartItems() {

      fetch('/cart.js', { credentials: 'same-origin' })
         .then(function(response) {
         return response.json();
         })
         .then(function(cart) {
            let items = cart.items;
            let cart_items = document.querySelector('.cart-items');
            cart_items.innerHTML = '';
            
            $('.cart-total').html(theme.Currency.formatMoney(cart.total_price, theme.moneyFormat));
            $('[data-cart-count]').html(cart.item_count);

            for(i=0; i < items.length; i++) {
               var item_div = document.createElement('li');
               item_div.classList.add('cart-item', 'grid');
         
               var img_grid = document.createElement('div');
               img_grid.classList.add('grid__item', 'one-third', 'item-image');
               
               // item image
               var img = document.createElement('img');
               img.setAttribute('src', items[i].image);
         
               img_grid.appendChild(img);
               item_div.appendChild(img_grid);
         
               var details_grid = document.createElement('div');
               details_grid.classList.add('grid__item', 'two-thirds', 'item-details');
         
               // Item title
               var title = document.createElement('p');
               title.innerHTML = items[i].title;
         
               // Item price
               var price = document.createElement('strong');
               price.innerHTML = theme.Currency.formatMoney(items[i].price, theme.moneyFormat);
       
               // Item quantity wrapper
               var quantity = document.createElement('div');
               quantity.classList.add('quickadd-quantity-input', 'cart-quantity');
       
               // Minus button
               var minus_button = document.createElement('div');
               minus_button.classList.add('product-minus');
               minus_button.setAttribute('data-product-minus', '');

               var minus_img = document.createElement('img');
               minus_img.setAttribute('src', theme.images.minus);

               minus_button.appendChild(minus_img);
       
               // Number input
               var number_input = document.createElement('input');
               number_input.setAttribute('type', 'number');
               number_input.setAttribute('name', 'quantity');
               number_input.setAttribute('value', items[i].quantity);
               number_input.setAttribute('pattern', '[0-9]*');
               number_input.setAttribute('data-line-item', i + 1); // Add 1 because index needs to start from 1
               number_input.classList.add('stepper-input');
       
               // Plus button
               var plus_button = document.createElement('div');
               plus_button.classList.add('product-plus');
               plus_button.setAttribute('data-product-plus', '');

               var plus_img = document.createElement('img');
               plus_img.setAttribute('src', theme.images.plus);

               plus_button.appendChild(plus_img);
       
               // Build quantity element
               quantity.appendChild(minus_button);
               quantity.appendChild(number_input);
               quantity.appendChild(plus_button);
         
               // Build grid in element
               details_grid.appendChild(title);
               details_grid.appendChild(price);
               details_grid.appendChild(quantity);
         
               // Add grid and item to mini cart
               item_div.appendChild(details_grid);
               cart_items.appendChild(item_div);
             }

             handleQuantityChange();
         })
         .catch(function(error) {
         // eslint-disable-next-line no-console
         console.log(error);
         });
	 }

	function _toggleCart(e) {
		$('.cart-trigger').toggleClass('active');
		$('.cart-mask').fadeToggle('fast');
	}

	function _AddToCart(e) {
		e.preventDefault();
		let form = e.target;  
		
		fetch('/cart/add.js', {
			 method: 'POST',
			 credentials: 'same-origin',
			 headers: {
				 'Content-Type': 'application/x-www-form-urlencoded',
				 'X-Requested-With': 'XMLHttpRequest'
			 },
			 body: theme.Helpers.serialize(form)
		 })
			 .then(function(response) {
				 return response.json();
			 })
			 .then(function(json) {
				 if (json.status && json.status !== 200) {
					 var error = new Error(json.description);
					 error.isFromServer = true;
					 throw error;
				 }
					buildCartItems();
					if(window.location.href.indexOf("/search?q=") === -1 ){
						_toggleCart();
					}
			 })
			 .catch(function(error) {
				 console.log(error);
			 });
 }

		var buttons = document.querySelectorAll('.quick-add-form');
		buttons.forEach((item) => {
			item.addEventListener('submit', (e) => {
				e.preventDefault();
				_AddToCart(e);
			})
		})
		
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);

		var loggedOutButtons = document.querySelectorAll('[logged-out]'); 
	
		if (loggedOutButtons !== null ) {
			loggedOutButtons.forEach((item) => {
				item.addEventListener('click', () => {
					event.preventDefault()
					promptLoginModal.open()
				})
			})
		}

		$(function() {
			setTimeout(function(){ 
				// console.log('running match')
				$('.product-card__title ').matchHeight();
				$('.short-desc').matchHeight();
				$('.grown-in').matchHeight();
				$('.dietary-requirements').matchHeight();
				$('.match-height').matchHeight();
			}, 1000);
		});
	};
})(); 